import { render, staticRenderFns } from "./ModalUploadExam.vue?vue&type=template&id=6c0c0830"
import script from "./ModalUploadExam.vue?vue&type=script&lang=js"
export * from "./ModalUploadExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports